module.exports = __webpack_public_path__ + "static/spawn_of_kyuss-a70bcccfaabab9a6b7c8925f280ace0b.jpeg";